import React, {useState, useEffect, useContext} from "react"
import {Button, Box, Typography} from "@mui/material"
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import Grid from '@mui/material/Grid';
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useHistory, useParams} from "react-router";
import {Item} from "./Item";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import {create, getById, update} from "@api/category";
import {Alert} from "@material-ui/lab";

const useStyles = makeStyles({
    main: {
        marginTop: '2em',
    },
    title: {
        fontSize: '24px',
        fontWeight: 'bold',
    },
    error: {
        marginBottom: '10px',
    },
    saveBlock: {
        marginTop: '20px',
    },
    label: {
        fontSize: '16px',
        fontWeight: 'bold',
    },
    input: {
        margin: '0px',
    },
});

export const EditCategory = () => {
    const classes = useStyles();
    let {id} = useParams();
    const history = useHistory();
    const {setLoading} = useContext(LoadingContext);
    const {setErrorMessage} = useContext(MessageContext);
    const defaultCategory = {
        name: '',
        free: 0,
        purchased: 0,
        active: false,
        indId: Math.floor(Math.random() * 100000000)
    }
    const [category, setCategory] = useState(defaultCategory)
    const [error, setError] = useState('')

    const createCategory = async () => {
        try {
            setError('');
            setLoading(true);
            setErrorMessage(null);

            await create(category)
            history.push(`/categories`)
        } catch (e) {
            setError(e);
            setErrorMessage(e);
        }
        setLoading(false);
    }

    const updateCategory = async (id) => {
        try {
            setError('');
            setLoading(true);
            setErrorMessage(null);

            await update({...category, subCategories: category.subCategories.filter((subCategory) => subCategory)})
            history.push(`/categories`)
        } catch (e) {
            setError(e);
            setErrorMessage(e);
        }
        setLoading(false);
    }

    const save = () => {
        if (id) {
            updateCategory(id)
        } else {
            createCategory()
        }
    }

    const add = () => {
        if (!category.subCategories) category.subCategories = []

        category.subCategories.push(defaultCategory)

        setCategory({...category})
    }

    const remove = (ind) => {
        category.subCategories.splice(ind, 1)
        setCategory({...category})
    }

    const onChange = async (category) => {
        setCategory({...category})
    }

    const updateSubCategories = async (subCategory) => {
        category.subCategories.filter((subCategory) => subCategory).forEach((subCategory_) => {
            if(subCategory_.id === subCategory.id){
                subCategory_ = subCategory
            }
        })

        setCategory({...category})
    }

    // const handleSubmit = (event) => {
    //     const data = new FormData(event.currentTarget);
    //     console.log(data)
    //     debugger
    // }

    useEffect(() => {
        if (id) {
            const loadCategoryById = async (id) => {
                try {
                    setLoading(true);
                    setErrorMessage(null);
                    const category = await getById(id)
                    setCategory(category)
                } catch (e) {
                    setErrorMessage(e);
                }
                setLoading(false);
            }

            loadCategoryById(id)
        } else {
            setCategory({})
        }
    }, [id, setErrorMessage, setLoading])

    return (
        <Grid className={classes.main} container spacing={2}>
            <Grid item xs={12}>
                <Box display={"flex"} justifyContent={"space-between"}>
                    <Typography className={classes.title} component="h2">My Categories</Typography>
                </Box>
            </Grid>
            <Grid item xs={6} md={4}>
                <Typography className={classes.label} component="h4">Category Name</Typography>
            </Grid>
            <Grid item xs={6} md={8}>
                <Typography className={classes.label} component="h4">Win Chance</Typography>
            </Grid>
            {category ? <>
                <Item category={category} onChangeData={onChange} remove={remove} key={'category'} ind={123456878}/>
                <Grid item md={3}/>
                {category?.subCategories ? category.subCategories.filter((subCategory) => subCategory).map((subCategory, ind) => (
                    <Item category={subCategory} onChangeData={updateSubCategories} remove={remove} ind={ind}/>
                )) : ''}
                <Grid item xs={12}>
                    <Button onClick={add} className={classes.label} variant="text"><AddCircleIcon/>Create
                        subcategory</Button>
                </Grid>
                <Grid item xs={12}>
                    {error && typeof error === 'object' && (
                        Object.keys(error).map(e => <Alert className={classes.error} severity="error">
                            {" "}
                            {e} - {error[e]}
                        </Alert> )
                    )}
                </Grid>
                <Grid item xs={12} className={classes.saveBlock}>
                    <Button variant="contained"
                            onClick={() => save()}
                            // type="submit"
                    >Save category</Button>
                </Grid></> : ''}
        </Grid>
    )
}